module.exports = __webpack_public_path__ + "img/partner1.fd5862bc.jpeg";